import library from './library.json' with {type: 'json'};
import previews from './previews.json' with {type: 'json'};
import {SLOT_LIMITS} from './catalog.js';

export const VISUAL_DIRECTION_LIBRARY = library;
export const VISUAL_DIRECTION_LIBRARY_VERSION = library.version;

const BY_ID = new Map(library.options.map(option => [option.id, option]));

export function optionById(id = '') {
  return BY_ID.get(String(id || '').trim()) || null;
}

export function optionsInCategory(category = '') {
  return library.options.filter(option => option.category === category);
}

export function previewFor(id = '') {
  return previews.entries[id] || {assetId: optionById(id)?.previewAssetId || '', image: null, video: null};
}

export function slotOf(option) {
  return option ? `${option.category}:${option.slot || 'main'}` : '';
}

export function slotLimit(slotKey = '') {
  return SLOT_LIMITS[String(slotKey).split(':')[0]] || 1;
}

const tokenize = value => String(value || '').toLowerCase().normalize('NFKD').replace(/[^a-z0-9×\s-]/g, ' ').split(/[\s-]+/).filter(token => token.length > 1);

const INDEX = library.options.map(option => {
  const fields = [
    [option.displayName, 6],
    [option.aliases.join(' '), 5],
    [option.id, 5],
    [option.creativeEffect, 3],
    [option.description, 3],
    [(option.bestFor || []).join(' '), 2],
    [option.metadata?.whenToUse, 2],
    [option.metadata?.howItWorks, 1],
    [option.promptFragment, 1]
  ];
  return {option, fields: fields.map(([text, weight]) => ({tokens: tokenize(text), text: String(text || '').toLowerCase(), weight}))};
});

export function searchVisualDirection(query = '', {limit = 24, category = ''} = {}) {
  const needle = String(query || '').trim().toLowerCase();
  const tokens = tokenize(needle);
  if (!tokens.length) return [];
  const results = [];
  for (const entry of INDEX) {
    if (category && entry.option.category !== category) continue;
    let score = 0;
    let matched = 0;
    for (const token of tokens) {
      let best = 0;
      for (const field of entry.fields) {
        if (field.tokens.includes(token)) best = Math.max(best, field.weight * 2);
        else if (field.tokens.some(item => item.startsWith(token))) best = Math.max(best, field.weight);
      }
      if (best) matched += 1;
      score += best;
    }
    if (!matched || matched < Math.ceil(tokens.length / 2)) continue;
    if (entry.fields[0].text.includes(needle)) score += 12;
    if (entry.option.id.toLowerCase() === needle) score += 40;
    results.push({option: entry.option, score});
  }
  return results.sort((a, b) => b.score - a.score || a.option.id.localeCompare(b.option.id)).slice(0, limit).map(item => item.option);
}
